import React, { useEffect, useState } from "react";
import api from "../setupAxios";
import { useDialog } from "../context/dialogContext";
import FiltrosAlumnos from "./FiltrosAlumnos";
import { estadoCita, fechaHoraES, msgError, useListado } from "../utils";

// Check-in: lista de todos con filtros y marcar si han llegado.
//   Marcar: confirmación emergente con el nombre.
//   Desmarcar: en rojo, con alarma y DOBLE confirmación.
export default function PanelCheckin() {
  const { confirmar, confirmarPeligro, avisar, exito } = useDialog();
  const [f, setF] = useState({});
  const [opciones, setOpciones] = useState({});
  const [ocupado, setOcupado] = useState(null);
  const { datos, cargando, error, recargar } = useListado("/checkin/alumnos", f);

  useEffect(() => { api.get("/checkin/opciones").then(({ data }) => setOpciones(data)).catch(() => {}); }, []);

  const llegada = async (a) => {
    if (!(await confirmar(`¿Confirmas que ${a.nombre} ha llegado?`))) return;
    setOcupado(a.id_user);
    try {
      const { data } = await api.post("/checkin/llegada", { id_alumno: a.id_user });
      exito(`${a.nombre}: llegada registrada`);
      if (data.cita_liberada) avisar(`Tenía un check-in posterior (${data.cita_liberada.fecha} ${data.cita_liberada.hora}): se ha liberado ese hueco.`);
    } catch (e) { avisar(msgError(e)); }
    setOcupado(null);
    recargar();
  };

  const desmarcar = async (a) => {
    if (!(await confirmarPeligro(`Vas a quitar la llegada de ${a.nombre}.`, { titulo: "Desmarcar llegada", boton: "Sí, desmarcar" }))) return;
    if (!(await confirmarPeligro(`Segunda comprobación: ¿seguro que ${a.nombre} NO ha llegado?\nLa cita que se liberó al llegar no se recupera.`,
                                 { titulo: "Confirma de nuevo", boton: "Desmarcar definitivamente" }))) return;
    setOcupado(a.id_user);
    try { await api.post("/checkin/desmarcar", { id_alumno: a.id_user }); exito(`${a.nombre}: llegada desmarcada`); }
    catch (e) { avisar(msgError(e)); }
    setOcupado(null);
    recargar();
  };

  const llegados = datos.filter((a) => a.llegado).length;

  return (
    <div className="card">
      <div className="card-headrow">
        <h3>Check-in <span className="count">{datos.length}</span></h3>
        <button className="btn btn-refresh" onClick={recargar}>🔄 Actualizar</button>
      </div>
      <div className="ci-resumen">
        <div className="ci-chip verde"><b>{llegados}</b><span>han llegado</span></div>
        <div className="ci-chip ambar"><b>{datos.length - llegados}</b><span>pendientes</span></div>
      </div>
      <FiltrosAlumnos f={f} setF={setF} opciones={opciones} campos={["q", "piso", "estado", "fecha", "franja", "llegado"]} />
      {error && <div className="alert alert-error">{error}</div>}
      <div className="tablewrap">
        <table className="ci-tabla t-checkin">
          <thead><tr><th>Alumno</th><th>Piso / hab.</th><th>Check-in</th><th>Llegada</th><th /></tr></thead>
          <tbody>
            {cargando && datos.length === 0 && <tr><td colSpan={5} className="empty">Cargando…</td></tr>}
            {!cargando && datos.length === 0 && <tr><td colSpan={5} className="empty">No hay alumnos con esos filtros.</td></tr>}
            {datos.map((a) => {
              const est = estadoCita(a);
              return (
                <tr key={a.id_user} className={a.llegado ? "llegado" : ""}>
                  <td className="ci-nombre" title={a.email}>{a.nombre}</td>
                  <td title={a.pisos_texto}>{a.pisos_texto || <span className="muted">—</span>}</td>
                  <td><span className={`badge ${est.clase}`}>{est.texto}</span></td>
                  <td>{a.llegado
                    ? <span className="badge badge-green">✅ Llegado {fechaHoraES(a.llegada_hora)}{a.llegada_por ? ` · ${a.llegada_por}` : ""}</span>
                    : <span className="badge badge-gray">Pendiente</span>}</td>
                  <td>{a.llegado
                    ? <button className="btn btn-mini btn-danger" disabled={ocupado === a.id_user} onClick={() => desmarcar(a)}>Desmarcar</button>
                    : <button className="btn btn-mini btn-success" disabled={ocupado === a.id_user} onClick={() => llegada(a)}>Ha llegado</button>}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
